import React, { useEffect, useState } from "react";
import { HTTP } from "../../../api/resources";
import Select from "react-select";

export default function PageMemberships({pageId, allData, groups, members}) {
    const [editing, setEditing] = useState(false)
    const [showing, setShowing] = useState(false)
    const [saving, setSaving] = useState(false)
    const [showMessage, setShowMessage] = useState('Show Memberships')
    const [selectedMember, setSelectedMember] = useState(null)
    const [selectOptions, setSelectOptions] = useState([])
    const [editMembers, setEditMembers] = useState([])
    const [inititialized, setInitialized] = useState(false)

    // rerender based on certain value changes
    useEffect(() => {
        decideShowMessage()
    }, [showing, editMembers, selectOptions])

    // one time render use effect
    useEffect(() => {
        let data = initializeEditMembers()
        initializeSelectOptions(data)
    }, [])

    // set the edit members with previous data
    const initializeEditMembers = () => {
        let data = []

        if (groups && groups.length > 0) {
            let groupsData = allData.filter(data => data.type == 'group')
            let matchedData = groupsData.filter(data =>
                groups.find(group => group.id === data.real_id)
            )
            data = data.concat(matchedData)
        }

        if (members && members.length > 0) {
            let membersData = allData.filter(data => data.type == 'user')
            let matchedData = membersData.filter(data =>
                members.find(member => member.id === data.real_id)
            )
            data = data.concat(matchedData)
        }

        setEditMembers(data)
        return data
    }

    // set the options available for selection
    const initializeSelectOptions = (data = null) => {
        let array = []
        let groupArray = []
        let userArray = []

        if (data && data.length > 0) {
            let combinedArray = allData.filter(d =>
                !data.some(i => i.id == d.id && i.type == d.type)
            )
            array = combinedArray
        } else {
            array = allData
        }

        groupArray = array.filter(arr => arr.type == 'group')
        userArray = array.filter(arr => arr.type == 'user')

        userArray = _.orderBy(userArray, ['name'], ['asc'])
        groupArray = _.orderBy(groupArray, ['name'], ['asc'])
        array = [...groupArray, ...userArray]

        setSelectOptions(array)
    }

    // handle closing of the component
    const handleClose = () => {
        let updatedMembers = []

        if (editMembers && editMembers.length > 0) {
            let removeMembers = editMembers.filter(member => member.not_saved && member.not_saved == true)
            if (removeMembers && removeMembers.length > 0) {
                updatedMembers = editMembers.filter(member => !member.not_saved || member.not_saved == false)
                Alert.show('notice', 'Removed unsaved changes')
                setEditMembers(updatedMembers)
                initializeSelectOptions(updatedMembers)
            }
        }
        setEditing(false)
        setShowing(false)
    }

    // handle the submition of data
    const handleSubmit = () => {
        let users = []
        let group = []

        if (editMembers) {
            let userData = editMembers.filter(member => member.type == 'user')
            userData.map(user => users.push(user.real_id))

            let groupData = editMembers.filter(member => member.type == 'group')
            groupData.map(member => group.push(member.real_id))
        }

        if (users) {
            setSaving(true)
            HTTP.patch(`/community/membership/${pageId}`, {
                member_ids: users
              })
            .then((response) => {
                if (!group) {
                    Alert.show("notice", "Updated successfully");
                    setSaving(false)
                    setTimeout(() => {window.location.reload()}, 1000)
                }
            })
            .catch((e) => {
                Alert.show("error", "Could not update, try again");
                setSaving(false);
                setTimeout(() => {window.location.reload()}, 1000)
            });
        }

        if (group) {
            if (!users) setSaving(true);
            const data = { groups: group, type: 'community' }
            HTTP.patch(`/groups/${pageId}/update`, data).then(response => {
                Alert.show("notice", "Updated successfully");
                setSaving(false)
                setTimeout(() => {window.location.reload()}, 1000)
            }).catch(e => {
                Alert.show("error", "Could not update, try again");
                setSaving(false);
                setTimeout(() => {window.location.reload()}, 1000)
            })
        }
    }

    // add members to the list
    const addMember = () => {
        if (!selectedMember) return

        // prepare the members data
        selectedMember.not_saved = true
        setEditMembers([...editMembers, selectedMember])

        // remove from options
        let updatedMembers = selectOptions.filter(option => option.id !== selectedMember.id)
        setSelectOptions(updatedMembers)
        setSelectedMember(null)
    }

    // remove members from the list
    const removeMember = (member) => {
        if (!member.not_saved) {
            if (member.type == 'group') removeGroup(member)
            if (member.type == 'user') removeUser(member)
        }
        let updatedMembers = editMembers.filter(m => m.id !== member.id)
        setEditMembers(updatedMembers)
        Alert.show('notice', 'Removed successfully')
        initializeSelectOptions(updatedMembers)
        setTotalSelection(editMembers)
    }

    // remove user
    const removeUser = async (user) => {
        setSaving(true)
        HTTP.delete(`/community/membership/${pageId}/${user.real_id}`).then(response => {
          setSaving(false);
        }).catch(e => {
          setSaving(false);
          Alert.show('error', 'member not removed! Try again or refresh.');
          window.location.reload();
        })
      }

    // remove group
    const removeGroup = async (group) => {
        setSaving(true)
        HTTP.delete(`/groups/${pageId}/${group.real_id}/delete?type=community`).then(response => {
          setSaving(false);
          Alert.show('notice', 'Group and members removed');
          setTimeout(() => {window.location.reload()}, 1000)
        }).catch(e => {
          setSaving(false);
          Alert.show('error', 'Groups not removed! Try again or refresh.');
        })
      }

    // decide what the show message displays
    const decideShowMessage = () => {
        if (showing) setShowMessage('Hide Memberships')
        if (!showing) setShowMessage('Show Memberships')
    }

    const getAmount = () => {
        if (editMembers.length < 5) return editMembers.length
        if (editMembers.length >= 5) return 5
    }

    const determineRoute = (member) => {
      if (member.type == 'user') return `/b/${member.real_id}`
      if (member.type == 'group') return `/group/${member.real_id}`
    }

    useEffect(() => {})


  return(
    <div id="user-group-form" className="card">
        <div className="card-header flex-header">
            <div>
                <h4 className="card-title">Memberships</h4>
                {showing && <small>Showing all {editMembers.length} memberships</small>}
                {!showing && !editing && <small>Showing {getAmount()} of {editMembers.length}</small>}
            </div>
        <div>
          {editing && (
            <div>
              <button onClick={handleClose} name="button" className="btn btn-outline-danger mr-1">
                Close
              </button>
              <button onClick={handleSubmit} name="button" className="btn btn-primary">
                {saving && (<i className="fa fa-spinner-third fa-spin mr-2"></i>)}
                Save
              </button>
            </div>
          )}

          {!editing &&
            <button onClick={() => setShowing(!showing)} className="btn btn-primary mr-1">
                 { showMessage }
            </button>
          }

          {!editing && (
            <button onClick={() => setEditing(true)} className="btn btn-primary"> Edit Memberships</button>
          )}
        </div>
      </div>

      {editing && (
        <div className="form-group">
          <label>Add Members</label>
          <div className="input-group">
            <Select
              className="form-control select-Members"
              classNamePrefix="select-Members"
              onChange={(member) =>
                setSelectedMember(member)
              }
              options={selectOptions}
              getOptionLabel={member => `${member.name}` }
              getOptionValue={member => member.id}
              value={selectedMember}
            />
            <div className="input-group-append">
              <button onClick={() => addMember()} className="btn btn-primary">Add</button>
            </div>
          </div>
        </div>
      )}

    <div className="list-group list-group-flush">
        {(editing || showing) && editMembers.map((member) => (
          <div key={member.id} id={`group-table-${member.id}`} className="list-group-item">
            <div className='list-group-item-body'>
              <div className='list-group-item-body-main mb-2'>
                <span className="mr-1">{member.name}</span>
                <a
                  href={
                    determineRoute(member)
                  }
                  target="_blank"
                  rel="noreferrer"
                ></a>
              </div>
            </div>
            {editing && (<div className='list-group-item-actions d-none-mobile'>
              { member.not_saved && (<span className="badge badge-sm badge-warning badge-pill mr-2">Not Saved</span>)}

              <button
                onClick={() => removeMember(member)}
                className="btn btn-sm btn-danger">Remove</button>
            </div>
            )}

          </div>)
        )}

        {!editing && !showing && editMembers.slice(0, 5).map((member) => (
          <div key={member.id} id={`group-table-${member.id}`} className="list-group-item">
            <div className='list-group-item-body'>
              <div className='list-group-item-body-main mb-2'>
                <span className="mr-1">{member.name}</span>
                <a
                  href={
                    determineRoute(member)
                  }
                  target="_blank"
                  rel="noreferrer"
                ></a>
              </div>
            </div>
            {editing && (<div className='list-group-item-actions d-none-mobile'>
              { member.not_saved && (<span className="badge badge-sm badge-warning badge-pill mr-2">Not Saved</span>)}

              <button
                onClick={() => removeMember(member)}
                className="btn btn-sm btn-danger">Remove</button>
            </div>
            )}

          </div>)
        )}
      </div>
    </div>
  );
}
